<template>
    <div id="app">
        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
        <!-- <router-view></router-view> -->
        <!-- <xuanfuqiu :position="position" v-if="!$route.meta.suspension" @click="qixiClick">

        </xuanfuqiu> -->

    </div>
</template>
<script>
// import xuanfuqiu from '@/components/floatBtn.vue'
//  import VConsole from 'vconsole';
//  let vConsole = new VConsole();
export default {
    // components: {
    //     xuanfuqiu
    // },
    data() {
        return {
            position: {
                bottom: '100px',
                right: 0
            },
        }
    },
    created() {
        //console.log(process.env.VUE_APP_PAY_URL, 'process.env.VUE_APP_PAY_URL');
    },
    mounted() {
        window.addEventListener("offline", this.updateOnlineStatus);//监听用户是否断网
        window.addEventListener("orientationchange", this.rotate)//监听用户是否竖屏
        // 安卓键盘收起
        window.addEventListener('focus', this.checkKeyboard);
    },
    methods: {
        rotate() {
            if (document.documentElement.clientWidth > document.documentElement.clientHeight) {
                //this.$toast('请切换至竖屏操作')
            } else {
                //this.$toast('my横屏')
            }
        },
        wxshareInfo(e) {
            let _this = this;
            let wx = _this.wx
            var shareTitle = "先领红包再寄件，最低3元寄全国"
            var href = window.location.href.split('#')[0]
            //var shareLink = window.location.origin + "/express/index.html#/express?shareId=" + localStorage.getItem('memberId') //测试
            var shareLink = window.location.origin + "/express/#/express?shareId=" + localStorage.getItem('memberId') //打开的链接
            var shareImg = localStorage.getItem('pubHeadPath') || "https://www.pyjkd.com/pro/image/shareImg.jpg" //图片路径
            var shareDesc = localStorage.getItem('wechatName') + "，寄啥都便宜！天天领红包，每天都有机会免费寄快递！";
            let formData = new FormData();
            formData.append('url', encodeURIComponent(href))
            this.$post('/client-util/getSignature', formData).then(res => {
                if (res.code == '1') {
                    let data = res.data;
                    if (!data) {
                        return false
                    }
                    wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: localStorage.getItem('appId') ||
                            'wx77a894266fc4acb8', // 必填，公众号的唯一标识
                        timestamp: data.timestamp, // 必填，生成签名的时间戳
                        nonceStr: data.nonceStr, // 必填，生成签名的随机串
                        signature: data.signature, // 必填，签名
                        jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline', 'wx-open-launch-weapp', 'scanQRCode'], // 必填，需要使用的JS接口列表
                        openTagList: ['wx-open-launch-weapp']
                    });
                    wx.ready(function () {
                        //分享到朋友圈
                        wx.onMenuShareAppMessage({
                            title: shareTitle, // 分享标题
                            desc: shareDesc, // 分享描述
                            link: shareLink, // 分享链接
                            imgUrl: shareImg, // 分享图标
                            success: function () {
                            }
                        })
                        //分享给朋友
                        wx.onMenuShareTimeline({
                            title: shareTitle, // 分享标题
                            desc: shareDesc, // 分享描述
                            link: shareLink, // 分享链接
                            imgUrl: shareImg, // 分享图标
                            success: function () {
                                console.log('分享给朋友onMenuShareTimeline')
                            }
                        })
                    })
                    wx.error(function (res) {
                        console.log('默认生成失败', res);
                    })
                } else if (res.code == 1004) {
                    _this.getToken()
                } else {
                    _this.$toast(res.msg)
                }
            })
        },
        saveShareId() {//shareid存本地
            let shareId = this.$route.query.shareId || null;
            let shareRedId = this.$route.query.shareRedId || null;
            let invitedMemberId = this.$route.query.invitedMemberId || null;
            let promoteCodeId = this.$route.query.promoteCodeId || null;
            let expressId = this.$route.query.expressId || null;
            let memberId = localStorage.getItem('memberId')
            if (shareId) {
                localStorage.setItem('shareId', shareId);
            }
            if (expressId) {
                localStorage.setItem('expressId', expressId)
            }
            if (memberId) {
                this.saveShareIdAdd()
            }
            if (shareRedId) {
                localStorage.setItem('shareRedId', shareRedId)
            }
            if (promoteCodeId && invitedMemberId) {
                localStorage.setItem('promoteCodeId', promoteCodeId)
                localStorage.setItem('invitedMemberId', invitedMemberId)
            }
        },
        saveShareIdAdd() {//创建邀约关系
            let _this = this;
            let invitedMemberId = localStorage.getItem('shareId') || null;
            let expressId = localStorage.getItem('expressId') || null;
            if (invitedMemberId) {
                this.$post('/client-member/addInvited', {
                    invitedMemberId: invitedMemberId,
                    expressId: expressId
                }).then(res => {
                    if (res.code === 1) {
                        localStorage.removeItem('shareId');
                    }
                })
            }
        },
        updateOnlineStatus(e) {
            const { type } = e;
            this.onLine = type === "online";
            this.$toast('网络不可用')
        },
        getQueryVariable(url, variable) {
            var query = url.split("?")[1]; // 根据“?”切割数组，截取“?”之后的字符串
            // ['https://qq.com','appid=1234567890&name=Zdf']
            var vars = query.split("&"); // 根据“&”切割成数组
            // ['appid=1234567890','name=Zdf']
            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                // ['appid','1234567890']
                if (pair[0] == variable) return pair[1]; // 没有花括号默认执行第一个js语句
            }
            return (false);
        },
        getInfo() {//获取用户个人信息
            let _this = this;
            let urlState = localStorage.getItem("urlState") || "";
            let token = localStorage.getItem('TOKEN') || null;
            if (token === null || token === 'null') {
                let url = window.location.href
                if (url.indexOf('code') > -1 && urlState !== '') {
                    let code = _this.getQueryVariable(url, 'code')
                    localStorage.setItem('code', code)
                    if (localStorage.getItem('code')) {
                        localStorage.removeItem('urlState');
                        _this.GLOBAL.startLoading('加载中...')		//加载动画
                        _this.$post('/client-search/searchHome', {
                            code: localStorage.getItem('code'),
                            state: _this.getQueryVariable(url, 'state') || 'sfjregi',
                        }).then((res) => {
                            if (res.code === 1) {
                                _this.GLOBAL.endLoading()
                                //pay_page  payPage
                                // 字段意思：commonPage通用页面,currentPage当前页面
                                try {
                                    if (res.data.openid && res.data.memberId) {
                                        localStorage.setItem('memberId', res.data.memberId);
                                        localStorage.setItem('TOKEN', res.token);
                                        localStorage.setItem('nickHead', res.data.nickHead);
                                        localStorage.setItem('nickName', res.data.nickName);
                                        localStorage.setItem('openid', res.data.openid);
                                        localStorage.removeItem('code');
                                        this.$router.push({
                                            path: '/transfer',
                                            query: {
                                                path: this.$router.history.current.path
                                            }
                                        })
                                    } else {
                                        _this.$toast(res.msg)
                                    }
                                } catch (e) {
                                }
                            } else if (res.code == 1004) {
                                _this.getToken()
                            } else {
                                _this.$toast(res.msg)
                            }
                        }).catch((err) => {
                            _this.getAppId();
                        })
                    }
                } else {
                    _this.getAppId()
                }
            } else {
                this.wxshareInfo()//默认的分享
                let minOriginAccountId = localStorage.getItem('minOriginAccountId') || null;
                let payPage = localStorage.getItem('payPage') || null;
                let wechatName = localStorage.getItem('wechatName') || null;
                let appId = localStorage.getItem('appId') || null;
                if ((minOriginAccountId === null || minOriginAccountId === 'null') || (payPage === null || payPage === 'null') || (wechatName === null || wechatName === 'null') || (appId === null || appId === 'null')) {
                    this.getWechatName()//获取当前公众号名字
                }
            }
        },
        getWechatName() {
            this.$post('/client-center/tenantInfo', {}).then((res) => {
                if (res.code == 1) {
                    localStorage.setItem('payPage', res.data.payPage);
                    localStorage.setItem('wechatName', res.data.wechatName);
                    localStorage.setItem('appId', res.data.publicAppid)
                    localStorage.setItem('minOriginAccountId', res.data.minOriginAccountId);
                } else if (res.code == 1004) {
                    _this.getToken()
                } else {
                    _this.$toast(res.msg)
                }
            })
        },
        getAppId() {
            let _this = this;
            localStorage.setItem("urlState", "urlState");
            let url = location.href;
            console.log('app.js tenantInfo')
            _this.GLOBAL.startLoading('加载中...')		//加载动画
            this.$post('/client-center/tenantInfo', {}).then((res) => {
                if (res.code == 1) {
                    _this.GLOBAL.endLoading()
                    try {
                        localStorage.setItem('payPage', res.data.payPage);
                        localStorage.setItem('wechatName', res.data.wechatName);
                        localStorage.setItem('appId', res.data.publicAppid)
                        localStorage.setItem('minOriginAccountId', res.data.minOriginAccountId);
                        localStorage.setItem('pubHeadPath', res.data.pubHeadPath)
                        this.saveShareId()//创建邀约关系
                    } catch (e) {
                    }
                    let componentDomain = res.data.componentDomains + process.env.VUE_APP_LOGIN_URL
                    let backUri = 'back_uri=' + encodeURIComponent(url);
                    let baseUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + res.data.publicAppid + '&redirect_uri=' + encodeURIComponent(componentDomain + '?' + backUri) + '&response_type=code&scope=snsapi_userinfo&state=STATE&component_appid=' + res.data.componentAppid + '#wechat_redirect';
                    window.location.href = baseUrl;
                } else if (res.code == 1004) {
                    _this.getToken()
                } else {
                    _this.$toast(res.msg)
                }
            }).catch((err) => {
            })
        },
        checkKeyboard() {
            // 获取屏幕高度
            const screenHeight = window.innerHeight;
            // 获取页面高度
            const bodyHeight = document.body.offsetHeight;
            // 判断键盘是否弹出
            if (bodyHeight > screenHeight) {
                // 键盘弹出，执行上移操作
                document.body.style.position = 'fixed';
                document.body.style.top = `-${(bodyHeight - screenHeight)}px`;
            } else {
                // 键盘收起，恢复位置
                document.body.style.position = '';
                document.body.style.top = '';
            }
        }
    },
    watch: {
        $route(to, from) {
            let _this = this;
            if (['express'].indexOf(to.name) == -1) {
                this.getInfo()
            }
            this.saveShareId()//创建邀约关系
            this.$store.state.pathname = to.name
        },
    },
    beforeDestroy() {
        window.removeEventListener("online", this.updateOnlineStatus);
        window.removeEventListener("offline", this.updateOnlineStatus);
        // 组件销毁前移除监听
        window.removeEventListener('resize', this.checkKeyboard);
        window.removeEventListener('focus', this.checkKeyboard);
    },
};
</script>
<style>
* {
    margin: 0;
    padding: 0;
    border: 0
}

body,
html {
    height: 100%;
    overflow: hidden;
}

#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    overflow-y: auto;
}

nav {
    padding: 30px;
}

nav a {
    font-weight: bold;
    color: #2c3e50;
}

nav a.router-link-exact-active {
    color: #42b983;
}

html {
    /*用于 获取 屏幕的可视宽高*/
    width: 100%;
    height: 100%;
    overflow: hidden;
}

body {
    /*让 body 初始 width 和 height 就 等于 页面可视区域的 宽高*/
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
}

@media screen and (orientation: landscape) {

    /*横屏样式*/
    body {
        transform-origin: 0 0;
        /* transform: rotateZ(90deg) translateY(-100%); */
        /* transform: rotateZ(0) translateY(100%); */
    }
}

::v-deep .van-radio__icon--checked .van-icon {
    background-color: red;
    border-color: red;
}
</style>
